import React from 'react';
import { breakpoints, Container } from '@web-for-marketing/react-ui';

const classes = {
    container: (spacing?: string, topSpacing?: string, bottomSpacing?: string) => ({
        paddingTop: topSpacing || spacing || '8rem',
        paddingBottom: bottomSpacing || spacing || '8rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            paddingTop: '4rem',
            paddingBottom: '4rem',
        },
    }),
};

interface SectionContainerProps extends React.ComponentProps<typeof Container> {
    spacing?: string;
    topSpacing?: string;
    bottomSpacing?: string;
}

export const SectionContainer = React.forwardRef<HTMLDivElement, SectionContainerProps>(function SectionContainer(
    { children, spacing, topSpacing, bottomSpacing, ...otherProps },
    ref
) {
    return (
        <Container ref={ref} css={classes.container(spacing, topSpacing, bottomSpacing)} {...otherProps}>
            {children}
        </Container>
    );
});
